import { User } from './user';

export class AuthResult {
  auth_token: string;
  user: User;
}



// WEBPACK FOOTER //
// ./src/app/core/models/auth-result.ts